import { Controller } from "stimulus"

// Stimulus controller for Bootstrap 4 modals
export default class extends Controller {
  connect() {
    // Open modal when it's inserted into the DOM
    $(this.element).modal("show")

    // Clean up the modal DOM node after it's fully hidden
    $(this.element).on("hidden.bs.modal", () => {
      this.element.remove()
    })
  }

  disconnect() {
    // Ensure cleanup if the frame is replaced
    $(this.element).modal("hide")
  }
}
